const faqs = [
  {
    q: '悟空影视真的完全免费吗？需要注册吗？',
    a: '是的，悟空影视完全免费，无需注册账号、无需绑定手机号、无需任何付费。打开网页即可直接观看全部内容。我们通过广告合作维持平台运营，不会向用户收取任何费用。',
  },
  {
    q: '视频播放卡顿怎么办？支持哪些清晰度？',
    a: '悟空影视采用全球 CDN 加速节点，智能匹配最优线路。支持 360P 至 1080P 多种清晰度，部分热门资源支持 4K 超清。如果遇到卡顿，建议切换播放线路或适当降低清晰度。大多数情况下播放非常流畅。',
  },
  {
    q: '悟空影视支持手机和平板观看吗？需要下载 APP 吗？',
    a: '完全支持！悟空影视已全面适配手机、平板和电脑端，无需下载任何 APP 或插件。直接在浏览器中打开网址即可流畅观影，iOS 和 Android 设备均可完美运行，播放体验与原生应用无异。',
  },
  {
    q: '资源更新频率如何？热门剧集多久能上架？',
    a: '平台每日更新 200+ 部影视内容。热门电视剧通常在播出后 2-4 小时内上线，热门电影则在流媒体上线后 24 小时内更新。综艺节目更新速度更快，基本同步各大平台播出进度。',
  },
  {
    q: '遇到无法播放或内容问题该如何反馈？',
    a: '您可以通过页面「联系我们」区域的反馈入口提交问题。请在反馈中尽可能详细描述遇到的问题（如剧集名称、具体集数、使用的设备等），我们的技术团队会在 24 小时内处理并回复。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 mb-1">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500">关于悟空影视，你想知道的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, idx) => (
            <div
              key={idx}
              className="rounded-xl bg-background-50 border border-background-200/60 p-5"
            >
              <h3 className="text-sm font-semibold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="flex-shrink-0 w-5 h-5 flex items-center justify-center rounded bg-primary-100 text-primary-600 text-xs font-bold mt-0.5">
                  Q
                </span>
                {faq.q}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed pl-7">{faq.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}